<p-confirmDialog /><app-card-content [border]="false" icon="pi pi-briefcase" title="Atividades" subtitle="Atividades econômicas e desenvolvidas"
    ><div card-header><app-botao-acoes label="Ações" [iconPos]="EInconPos.LEFT" [items]="itensAcoes" [iconColumns]="2" [permissaoUf]="pessoa()?.uf ?? null" /></div>
    <app-tab-container [(selected)]="selected" [options]="options" [useHeader]="false"
        ><app-tab-content value="CNAE"
            ><app-custom-table
                [metadata]="metadataCnae"
                [data]="cnaesTabela()"
                [columnOrder]="['idCnae', 'descricao', 'tipo']"
                [rowStyle]="rowStyleCnae"
                [loading]="carregando()"
                [totalRecords]="cnaes().length"
                [rows]="10"
                [cardColumns]="2"
                [permissaoUf]="pessoa()?.uf ?? null"
            />
            <div class="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
                <span class="font-semibold">Legenda:</span>
                <span class="inline-flex items-center gap-1"><span class="inline-block h-3 w-3 rounded-sm" style="background: #16a34a"></span> Cadastrado manualmente</span>
                <span class="inline-flex items-center gap-1"><span class="inline-block h-3 w-3 rounded-sm" style="background: #dc2626"></span> Sem indicativo de área médica</span>
            </div></app-tab-content
        ><app-tab-content value="ATIVIDADES"
            ><app-custom-table
                [metadata]="metadataAtividade"
                [data]="atividadesTabela()"
                [columnOrder]="['descricao', 'dtInclusao', 'dtExclusao']"
                [loading]="carregando()"
                [totalRecords]="atividades().length"
                [rows]="10"
                [cardColumns]="2"
                [permissaoUf]="pessoa()?.uf ?? null" /></app-tab-content></app-tab-container></app-card-content
><p-dialog appDialogoPadrao="pi pi-building" descricao="Classificação Nacional de Atividades Econômicas." [(visible)]="dialogCnae" header="CNAE" [appendTo]="'body'" [style]="{ width: 'min(94vw, 560px)' }"
    ><form [formGroup]="formCnae" class="flex flex-col gap-4">
        <div>
            <label class="font-semibold block mb-2">CNAE</label
            ><p-select
                fluid
                formControlName="idCnae"
                [options]="opcoesCnae()"
                optionLabel="descricao"
                optionValue="idCnae"
                appendTo="body"
                [filter]="true"
                filterBy="descricao"
                placeholder="Selecione o CNAE"
                [panelStyle]="{ 'max-width': 'min(90vw, 34rem)' }"
            />
        </div>
        <div class="flex gap-2 items-center"><p-checkbox binary formControlName="principal" inputId="principal" /><label for="principal">Atividade principal</label></div>
    </form>
    <ng-template #footer><p-button label="Cancelar" text (click)="dialogCnae = false" /><p-button label="Salvar" icon="pi pi-check" [loading]="salvando()" (click)="salvarCnae()" /></ng-template></p-dialog
><p-dialog appDialogoPadrao="pi pi-building" descricao="Atividade econômica exercida pelo prestador." [(visible)]="dialogAtividade" header="Atividade Desenvolvida" [appendTo]="'body'" [style]="{ width: 'min(94vw, 560px)' }"
    ><form [formGroup]="formAtividade" class="flex flex-col gap-4">
        <div>
            <label class="font-semibold block mb-2">Atividade</label
            ><p-select
                fluid
                formControlName="idAtividade"
                [options]="opcoesAtividade()"
                optionLabel="descricao"
                optionValue="idAtividade"
                appendTo="body"
                [filter]="true"
                filterBy="descricao"
                placeholder="Selecione a atividade"
                [panelStyle]="{ 'max-width': 'min(90vw, 34rem)' }"
            />
        </div>
    </form>
    <ng-template #footer><p-button label="Cancelar" text (click)="dialogAtividade = false" /><p-button label="Salvar" icon="pi pi-check" [loading]="salvando()" (click)="salvarAtividade()" /></ng-template
></p-dialog>
